import React from 'react';
import PropTypes from 'prop-types';
import { SFEntityID, starfishMediaType } from 'utils/types';
import { fetchAuthenticatedJSON, apiErrorMessage } from 'utils/request';
import ScoreDefinitionsView from './ScoreDefinitionsView';

export default class ScoreDefinitionsContainer extends React.Component {
    constructor() {
        super();
        this.state = {
            loading: true,
            ...this.getScoreDefinitions()
        };
    }

    getScoreDefinitions(data) {
        return {
            allScoreDefinitions: data ? data : [],
            positiveScoreDefinitions: data ? this.onlyPositiveScores(data) : [],
            negativeScoreDefinitions: data ? this.onlyNegativeScores(data) : []
        };
    }

    onlyPositiveScores(scoreDefinitions) {
        return scoreDefinitions.filter(scoreDefinition => Math.sign(scoreDefinition.weight) === 1);
    }

    onlyNegativeScores(scoreDefinitions) {
        return scoreDefinitions.filter(scoreDefinition => Math.sign(scoreDefinition.weight) !== 1);
    }

    componentDidMount() {
        const id = this.props.studentId;
        const URL = `../api/starfish/interventions-inventory/students/${id}/score-definitions`;
        fetchAuthenticatedJSON(URL, {
            method: 'GET',
            headers: {
                'Accept': starfishMediaType('interventionsinventory')
            }
        })
            .then(data => this.setState({...this.getScoreDefinitions(data)}))
            .catch(e => this.props.onFailure(apiErrorMessage(e)))
            .then(() => this.setState({loading: false}))
    }

    render() {
        return (
            <ScoreDefinitionsView loading={this.state.loading}
                                  loadingContent="Loading score factors..."
                                  positiveScoreDefinitions={this.state.positiveScoreDefinitions}
                                  negativeScoreDefinitions={this.state.negativeScoreDefinitions} />
        );
    }
}

ScoreDefinitionsContainer.propTypes = {
    studentId: SFEntityID.isRequired,
    onFailure: PropTypes.func.isRequired
};
